import React, { useEffect, useRef, useState } from 'react';

interface Props {
  // eslint-disable-next-line react/require-default-props
  tooltip?: boolean;
  tooltipText: string;
}

const Tooltip = ({ tooltip, tooltipText }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleClick = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as any)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [isOpen]);

  /**
   * By default to show the tooltip. So if the value is undefined we show the tooltip.
   * If tooltip is explicitly set to false (in the config), then we will not show it
   */
  if (tooltip !== false) {
    return (
      <p
        ref={ref}
        onBlur={() => setIsOpen(false)}
        className={`qred-help ${isOpen ? 'qred-active' : ''}`}
      >
        <svg
          viewBox="0 0 200 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => setIsOpen(!isOpen)}
          data-testid="tooltip"
        >
          <path d="M99.9155 0C68.7362 0 48.5413 12.7746 32.6862 35.557C29.8101 39.6898 30.6968 45.3563 34.7089 48.3984L51.5597 61.1754C55.6116 64.2477 61.3769 63.5293 64.5491 59.5551C74.3339 47.2969 81.5921 40.2391 96.8761 40.2391C108.893 40.2391 123.757 47.973 123.757 59.6262C123.757 68.4355 116.485 72.9598 104.619 79.6121C90.7823 87.3699 72.4714 97.0246 72.4714 121.177V125C72.4714 130.178 76.6687 134.375 81.8464 134.375H110.155C115.333 134.375 119.53 130.178 119.53 125V122.745C119.53 106.003 168.463 105.305 168.463 60C168.464 25.8813 133.072 0 99.9155 0ZM96.0011 145.882C81.0808 145.882 68.9421 158.021 68.9421 172.941C68.9421 187.861 81.0808 200 96.0011 200C110.921 200 123.06 187.861 123.06 172.941C123.06 158.021 110.921 145.882 96.0011 145.882Z" />
        </svg>
        {isOpen && (
          <span>
            <svg
              viewBox="0 0 200 200"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => setIsOpen(false)}
              data-testid="tooltip-close-button"
            >
              <path d="M137.909 100L194.767 43.142C201.744 36.1648 201.744 24.8523 194.767 17.8693L182.131 5.23295C175.153 -1.74432 163.841 -1.74432 156.858 5.23295L100 62.0909L43.142 5.23295C36.1648 -1.74432 24.8523 -1.74432 17.8693 5.23295L5.23295 17.8693C-1.74432 24.8466 -1.74432 36.1591 5.23295 43.142L62.0909 100L5.23295 156.858C-1.74432 163.835 -1.74432 175.148 5.23295 182.131L17.8693 194.767C24.8466 201.744 36.1648 201.744 43.142 194.767L100 137.909L156.858 194.767C163.835 201.744 175.153 201.744 182.131 194.767L194.767 182.131C201.744 175.153 201.744 163.841 194.767 156.858L137.909 100Z" />
            </svg>
            {tooltipText}
          </span>
        )}
      </p>
    );
  }
  return null;
};

export default Tooltip;
